import { useEffect, useLayoutEffect } from 'react'

import { useLocalErrorHandler } from 'hooks/useLocalErrorHandler'
import { BrowserRouter } from 'react-router-dom'
import useBoundState from 'store'
import { imageCache } from 'utils/ImageCache'
import GiftClose from 'assets/png/gift_close.png'
import GiftOpen from 'assets/png/gift_open.png'
import hero from 'assets/png/hero.png'
import Preload from 'utils/Preload'

import { Theme, initTheme } from '@interco/inter-ui'

import { Navbar } from './components/Navbar/Navbar'
import BaseBridge from './config/bridge/BaseBridge'
import NewRelicUtils from './config/monitoring/NewRelicUtils'
import { ErrorView } from './pages/shared'
import Routes from './routes'

const App = () => {
  const handlerError = useLocalErrorHandler()
  const blockBrowserAccessInPrd = process.env.NODE_ENV === 'production' && BaseBridge.isBrowser()
  const setHasError = useBoundState((state) => state.setHasError)
  const setIsDarkMode = useBoundState((state) => state.setIsDarkMode)

  useLayoutEffect(() => {
    getChooseTheme()
  }, [])

  useEffect(() => {
    imageCache.preloadImages([GiftClose, GiftOpen, hero])
  }, [])

  useEffect(() => {
    BaseBridge.hideNativeToolbar()
    NewRelicUtils.setInitSettings()
  }, [])

  useEffect(() => {
    if (blockBrowserAccessInPrd) {
      setHasError({
        title: 'Baixe o Super App do Inter',
        subTitle:
          'Para acessar este produto, faça o download do Super App na sua loja de aplicativos',
        disabledButton: true,
        disabledHome: true,
      })
    }
  }, [blockBrowserAccessInPrd, setHasError])

  const getChooseTheme = () => {
    BaseBridge.getAppInfo()
      .then((response) => {
        const { isDarkMode } = response
        setIsDarkMode(isDarkMode)

        initTheme(Theme.PF, isDarkMode)
      })
      .catch((error) => handlerError(error as Error, 'BaseBridge.getAppInfo'))
  }

  return (
    <BrowserRouter>
      <ErrorView />
      <Navbar />
      <Routes />
      <Preload />
    </BrowserRouter>
  )
}

export default App
